import { createContext } from "react";
import taxRegimesContextInterface from "./types";

const TaxRegimesContext = createContext<taxRegimesContextInterface>({
  taxRegimes: [],
  setTaxRegimes: () => {},
  isLoading: true,
  setIsLoading: () => {},
});

export default TaxRegimesContext;
